import { registerDecorator, ValidationArguments, ValidationOptions } from "class-validator";

// allows adding of only 2 valid nhs

// tslint:disable-next-line: ban-types
export function MaxAppointedNhs(validationOptions?: ValidationOptions): (object: Object, propertyName: string) => void {
	// tslint:disable-next-line: ban-types
	return (object: Object, propertyName: string): void => {
		registerDecorator({
			name: "MaxAppointedNhs",
			target: object.constructor,
			propertyName,
			constraints: [],
			options: validationOptions,
			validator: {
				validate(value: any[]): boolean {
					return MaxAppointedNhsConstraint(value);
				},
				defaultMessage(args: ValidationArguments): string {
					return "You can't appoint more than 2 NHS.";
				},
			},
		});
	};
}

export const MaxAppointedNhsConstraint = (spokesPersons: any[]): boolean => {
	return spokesPersons.filter((sp) => sp.isAppointed === true).length <= 2;
};
